import { JSX } from 'react'

import { HttpBody } from '@/lib/request.js'

import * as locally from '@/lib/locally.js'

import * as company_storage from '@/storage/company.js'


// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Loader from '@/components/ui/loader.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Carte from '@/components/ui/carte.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Menu from '@/components/ui/menu.tsx'




export enum Active
{
	view = 'view',
	update = 'update',

}

export type RetrieveResult = HttpBody<company_storage.THydratedDocumentType>




// eslint-disable-next-line @typescript-eslint/naming-convention
export function Name
(
	props: {
		value: RetrieveResult

	},

)
:	JSX.Element
{
	let { name } = props.value

	return (
		<Carte.Feild label="项目名称" w="72" align="start" boxSizing="content-box">
			<Carte.B>{name}</Carte.B>

		</Carte.Feild>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Contract
(
	props: {
		value: RetrieveResult

	},

)
:	JSX.Element
{
	let { contract_quantity } = props.value

	return (
		<Carte.Feild label="在职员工" w="32">
			<Carte.B>{contract_quantity}</Carte.B>

		</Carte.Feild>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Overdued
(
	props: {
		value: RetrieveResult

	},

)
:	JSX.Element
{
	let { overdued_quantity } = props.value

	return (
		<Carte.Feild label="协议到期" w="32">
			<Carte.B>{overdued_quantity}</Carte.B>

		</Carte.Feild>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Resigned
(
	props: {
		value: RetrieveResult

	},

)
:	JSX.Element
{
	let { resigned_quantity } = props.value

	return (
		<Carte.Feild label="归档合同" w="32">
			<Carte.B>{resigned_quantity}</Carte.B>

		</Carte.Feild>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Created
(
	props: {
		value: RetrieveResult

	},

)
:	JSX.Element
{
	let { created } = props.value

	return (
		<Carte.Feild label="创建于" flex="auto" minW="36" align="start">
			<Carte.B>{locally.date(created)}</Carte.B>

		</Carte.Feild>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Item
(
	props: {
		value: RetrieveResult

		view?(_id: string): void
		update?(_id: string): void

	},

)
:	JSX.Element

{
	let { _id } = props.value

	let on_active = (v: Active): void =>
	{
		if (v === Active.view)
		{
			props.view?.(_id)

		}

		if (v === Active.update)
		{
			props.update?.(_id)

		}


	}

	return (
		<Loader.Item
			display="flex"
			alignItems="center"
			p="4"
			bg="white"
			shadow="sm"
			rounded="md"
			minW="fit-content"
			_hover={{ bg: 'bg.subtle' }}
		>
			<Name value={props.value} />

			<Carte.Divider />

			<Contract value={props.value} />
			<Overdued value={props.value} />
			<Resigned value={props.value} />

			<Carte.Divider />

			<Created value={props.value} />

			<Menu.Root icon={<Menu.Icon />} active={on_active}>
				<Menu.Item value={Active.view}>查看</Menu.Item>

			</Menu.Root>

		</Loader.Item>

	)

}


export default function
(
	props: {
		keyword: string

		view?(_id: string): void
		update?(_id: string): void

	},

)
:	JSX.Element
{
	let params = { league: '^', keyword: props.keyword }

	let on_view = (id: string): void =>
	{
		props.view?.(id)

	}

	let on_update = (id: string): void =>
	{
		props.update?.(id)

	}

	return (
		<Loader.Root
			display="flex"
			flexDirection="column"
			gap="4"
			params={params}
			handle={company_storage.retrieves}
		>
			{v => <Item key={v._id} value={v} view={on_view} update={on_update} />}

		</Loader.Root>

	)


}
